module.exports = __webpack_public_path__ + "img/20190703154531YY截图20190703003010.78d0ebff.png";